export type AuthProvider = "password" | "google" | "microsoft";

// ユーザーデータの共通型
export interface UserData {
  organization_id: string;
  user_id: string;
}

// 認証済みユーザー（ad_idが存在する）
export interface AuthenticatedUserInfo {
  id: string;
  ad_id: string;
  email: string;
  user_data: UserData[];
  auth_providers?: AuthProvider[];
}

// 未認証ユーザー（招待ユーザー: ad_idが存在しない）
export interface NotAuthenticatedUserInfo {
  id: string;
  ad_id?: undefined;
  email: string;
  user_data: UserData[];
  auth_providers?: AuthProvider[];
}

// UserInfoはどちらかの型（Union Type）
export type UserInfo = AuthenticatedUserInfo | NotAuthenticatedUserInfo;

// 型ガード: 認証済みユーザーかどうかを判定
export function isAuthenticatedUserInfo(userInfo: UserInfo): userInfo is AuthenticatedUserInfo {
  return typeof userInfo.ad_id === "string" && userInfo.ad_id.length > 0;
}

// 型ガード: 未認証ユーザー（招待ユーザー）かどうかを判定
export function isNotAuthenticatedUserInfo(
  userInfo: UserInfo,
): userInfo is NotAuthenticatedUserInfo {
  return userInfo.ad_id === undefined;
}
